import { apiClient } from './apiClient';

export interface ReferralData {
  referralCode: string;
  referralUrl: string;
  qrCode: string;
}

/**
 * Сервис для работы с реферальной программой
 */
export const referralService = {
  /**
   * Получить реферальные данные пользователя (код, URL и QR код)
   */
  getReferral: () => {
    return apiClient.get<ReferralData>('/webapp/referral');
  },
};
